import { render, staticRenderFns } from "./new-translation.vue?vue&type=template&id=59a93ad1&scoped=true"
import script from "./new-translation.vue?vue&type=script&lang=js"
export * from "./new-translation.vue?vue&type=script&lang=js"
import style0 from "./new-translation.vue?vue&type=style&index=0&id=59a93ad1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a93ad1",
  null
  
)

export default component.exports